// extracted by mini-css-extract-plugin
export default {"container":"autoshops-list_container__44Hp2","autoshops-list":"autoshops-list_autoshops-list__v95Or"};